import { defineComponent as y, getCurrentInstance as p } from "vue";
import c from "./index12.js";
const S = y({
  name: "MsButton",
  components: {
    CsButtonLoadingSpinner: c
  },
  props: {
    isSecondary: {
      default: !1,
      type: Boolean
    },
    isInverted: {
      default: !1,
      type: Boolean
    },
    isGhost: {
      default: !1,
      type: Boolean
    },
    isDisabled: {
      default: !1,
      type: Boolean
    },
    isLoading: {
      default: !1,
      type: Boolean
    },
    isSmall: {
      default: !1,
      type: Boolean
    },
    isTextNoWrap: {
      default: !1,
      type: Boolean
    },
    isSquare: {
      default: !1,
      type: Boolean
    },
    target: {
      default: "_self",
      type: String
    },
    href: {
      default: "",
      type: String
    },
    rel: {
      default: void 0,
      type: String
    },
    type: {
      default: "button",
      type: String
    }
  },
  setup(e) {
    var o;
    const t = (o = p()) == null ? void 0 : o.proxy;
    function f() {
      var l;
      return n() && ((l = e.href) == null ? void 0 : l.length) > 0 ? e.href : null;
    }
    function u() {
      return n() && e.rel ? e.rel : null;
    }
    function r() {
      return n() ? e.target : null;
    }
    function i() {
      return n() ? null : e.type;
    }
    function n() {
      return !!e.href;
    }
    function s() {
      return n() ? "a" : "button";
    }
    function d() {
      return !!(t != null && t.$slots.icon);
    }
    function g() {
      const l = t == null ? void 0 : t.$slots.default, a = l && l.length ? l[0] : null;
      return a ? a.text : null;
    }
    return {
      getHref: f,
      getRel: u,
      getTag: s,
      getTarget: r,
      getType: i,
      isLink: n,
      hasIcon: d,
      getAriaLabel: g
    };
  }
});
export {
  S as default
};
